import * as React from 'react';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import usePageData from 'bundles/enroll-modal/data/usePageData';
import ReactPriceDisplay from 'bundles/ownable-products-common/components/ReactPriceDisplay';

import _t from 'i18n!nls/enroll';

import 'css!./__styles__/SubscriptionPriceHeader';

const S12nSubscriptionPriceHeader = () => {
  const { s12nDerivatives, s12nSubscriptionOwnableProduct } = usePageData();
  const s12nProductPrice = s12nSubscriptionOwnableProduct?.price || s12nDerivatives?.catalogPrice;

  if (!s12nProductPrice) {
    return null;
  }

  return (
    <div className="price-header headline-5-text">
      <FormattedMessage
        message={_t('{price} {perMonth}')}
        price={
          <ReactPriceDisplay
            currency={s12nProductPrice.currencyCode}
            value={s12nProductPrice.amount}
            hideCurrencyCode={true}
          />
        }
        perMonth={<span className="per-month">{_t('per month')}</span>}
      />
    </div>
  );
};

export default S12nSubscriptionPriceHeader;
